import { MotionProvider } from "@brexhq/metal-utils";
import { LazyMotion, m, type LazyProps } from "framer-motion";
import * as React from "react";

type CustomLazyMotionProps = Omit<LazyProps, "features">;

export const LazyMotionProvider = (props: CustomLazyMotionProps) => (
  <MotionProvider motion={m} wrapper={React.Fragment}>
    <LazyMotion
      features={async () => (await import("./framerFeatures")).default}
      strict={false}
      {...props}
    />
  </MotionProvider>
);
